var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"suites-page-container"},[_c('suites-header',{attrs:{"title":_vm.$t('suites.create_event.header')}}),_c('event-details-form',{attrs:{"loading":_vm.loading},on:{"submit":_vm.handleCreate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }